import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../components/Buttons';
import { performAction } from '../actions';
import { selectWork } from '../../Api/selectors';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../constants';
import { Loader } from '../../../components/Loader';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

const Container = styled.div`
  width: ${props => (props.maxWidth ? '100%' : '')};
`;

/* eslint-disable react/prefer-stateless-function */
class PerformActionButtonComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {}

  render() {
    if (this.props.work) return <Loader small />;

    if (this.props.primaryButton) {
      return (
        <Container maxWidth={this.props.maxWidth}>
          <ButtonComponent style={'ButtonSoftPrimary'} disabled={this.props.disabled} onClick={this.props.done}>
            {this.props.name || 'Akkoord'}
          </ButtonComponent>
        </Container>
      );
    }

    return (
      <Container maxWidth={this.props.maxWidth}>
        <Button className={this.props.className} disabled={this.props.disabled} onClick={this.props.done}>
          {this.props.name || 'Akkoord'}
        </Button>
      </Container>
    );
  }
}

PerformActionButtonComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_KANBAN_BOARD_PERFORM_ACTION),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    done() {
      dispatch(performAction(ownProps.action.id, ownProps.target.id, ownProps.payload, ownProps.onChange, true));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const PerformActionButton = compose(withConnect, withRouter)(PerformActionButtonComp);
